/**
 * Given a rubric type's variant presets and the rubrics already on a deck,
 * returns the variants not yet present.
 *
 * Identity is `variantKey`, never the title — an author renaming "Value Prop"
 * to "Value Proposition" must not cause a duplicate to be added back. Rubrics
 * created by hand carry no `variantKey` and are ignored, so a hand-rolled
 * rubric never suppresses its corresponding preset.
 */
export function missingRubricVariants<T extends { variantKey: string }>(
  variants: T[],
  existingVariantKeys: (string | undefined | null)[]
): T[] {
  const existing = new Set(
    existingVariantKeys.filter((key): key is string => !!key)
  )
  return variants.filter((variant) => !existing.has(variant.variantKey))
}
